/* Sprint 7C/D: shared Field wrapper.
 *
 * Visual port of the FuelEnquiryForm `Field` component (originally
 * defined inline at FuelEnquiryForm.js:1729) for the TradeRecap fuels
 * cards. ``hms-field`` prefix mirrors ``fef-field`` rules byte-for-
 * byte so the recap inputs render identical to enquiry/offer inputs.
 *
 * 2026-09-29: also the frame for the ui/fields controls (TextInput,
 * NumberInput, MoneyInput, DateInput, Select, TextArea). Three optional
 * props let a control wire itself up for screen readers; a caller that
 * omits them gets exactly the markup it got before:
 *   - htmlFor  ties the label to the control. The asterisk is then hidden
 *              from screen readers, since the control announces "required"
 *              itself.
 *   - hintId   id for the hint line, for the control's aria-describedby.
 *   - errorId  id for the error line, same.
 * The ref lands on the outer .hms-field div.
 */
import React, { forwardRef } from 'react';
import './Field.css';
import { smartCaseNode } from '../../utils/smartCase';

const Field = forwardRef(function Field(
  { label, error, children, hint, required = false, className = '', htmlFor, hintId, errorId },
  ref
) {
  return (
    <div ref={ref} className={`hms-field ${error ? 'hms-field-error' : ''} ${className}`.trim()}>
      {label && (
        <label className="hms-label" htmlFor={htmlFor}>
          {smartCaseNode(label)}
          {required && (
            <span className="hms-label-required" aria-hidden={htmlFor ? 'true' : undefined}> *</span>
          )}
        </label>
      )}
      {children}
      {hint && !error && <div className="hms-field-hint" id={hintId}>{hint}</div>}
      {error && <div className="hms-field-error-text" id={errorId}>{error}</div>}
    </div>
  );
});

export default Field;
